import React from 'react';
import { BodyM } from 'components/Typography/Typography';
import { makeStyles } from '@material-ui/styles';
import styles from 'assets/jss/material-dashboard-pro-react/views/tryAndBuy/tryAndBuyAccountNumberStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

interface AccountNumberProps {
	number: string | undefined;
}

const AccountNumber = (props: AccountNumberProps) => {
	const classes = useStyles();
	const { number } = props;

	return (
		<div className={classes.accountNumber}>
			<BodyM>{number}</BodyM>
		</div>
	);
};
export default AccountNumber;
